import { Component } from 'react'
import { Query } from 'react-apollo'


import { redirect } from 'Utils/helpers/routerHelper'
import { AppContext } from 'Utils/withReduxStore'
import { product, productVariables, getProductBy } from 'Utils/api/gql/types'
import productQuery from 'Utils/api/gql/queries/product'
import _app from './_app'
import ProductPageComponent from 'Components/ProductPageComponent'
import LoadingPage from 'Components/LoadingPage';

type InitialProps = {
  url_key: string
}

type PropType = InitialProps

class ProductPage extends Component<PropType> {
  static async getInitialProps({ query: { url_key }, res, initialState: { session: { customerData } } }: AppContext): Promise<Partial<PropType>> {
      if (!url_key) {
        redirect('/', res)
        return { }
      }

      url_key = typeof url_key === 'string'
        ? url_key
        : url_key[0]

      return { url_key }
  }


  render() {
    const { url_key } = this.props

    return (
      <Query<product, productVariables>
        query={productQuery}
        variables={{ getBy: getProductBy.URL, value: url_key }}
        fetchPolicy='cache-and-network'
        partialRefetch={true}
      >{({ error, data, refetch, loading }) => {
        if (loading) {
          return <LoadingPage />
        }
        if (error) {
          redirect('/')
          return null
        }
        if (data && data.product) {
          return (
            <ProductPageComponent
              key={data.product.id}
              product={data.product}
              originalUrl={url_key}
              refetch={refetch}
            />
          )
        }

        return <LoadingPage />

      }}</Query>
    )
  }
}

export default ProductPage
